import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { finalize, Observable, switchMap, tap } from "rxjs";
import { LoadingService } from "src/app/shared/services/loading.service";
import { ProgressService } from "src/app/shared/services/progress.service";
import { SessionService } from "src/app/shared/services/session.service";

@Injectable({
    providedIn: "root"
})
export class RegistrationGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private progressService: ProgressService,
        private router: Router,
        private loadingService: LoadingService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.sessionService.getSession().pipe(
            tap(() => {
                this.loadingService.setIsLoading();
            }),
            switchMap(async (session) => {
                if (!session || !session.email) {
                    return true;
                }

                await this.progressService.setProgressFromSession();

                const passportComplete = await this.progressService.isPassportComplete();

                if (!passportComplete) {
                    this.router.navigate(["", "how-it-works"]);
                    return false;
                } else if (passportComplete) {
                    this.router.navigate(["", "complete"]);
                    return false;
                }

                return false;
            }),
            finalize(() => {
                this.loadingService.setFinishedLoading();
            })
        );
    }

    private goHome() {
        this.router.navigate(["/"]);
    }
}
